import { Badge, Button, Table } from "antd";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import { SearchInput } from "../../../../shared/components/SearchInput";
import "./instituteLiveClass.scss";
import { FilterOutlined } from "@ant-design/icons";
import faker from "faker";
import moment from "moment";
import CardMenu from "../../../../shared/components/CourseComponents/CardMenu";
import InstituteLiveClassForm from "./InstituteLiveClassForm";
import { Form, Formik, FormikValues } from "formik";
import Filters from "../../../../shared/components/Filters";
import DropdownField from "../../../../shared/components/DropdownField";
import BranchService from "../../../../services/InstituteService/branch.service";
import { useParams } from "react-router-dom";
import { deserialize } from "serializr";
import { BranchMetaModel } from "../../../../models/InstituteModel/branches.model";
import SectionService from "../../../../services/InstituteService/section.service";
import LeaderboardService from "../../../../services/LeaderboardService/leaderboard.service";
import { MetaModel } from "../../../../models/CourseModels/SubjectModel/subject.model";
import InstituteService from "../../../../services/InstituteService/institute.service";
import LiveClassService from "../../../../services/InstituteService/liveClass.service";
import { LiveClassModel } from "../../../../models/InstituteModel/liveClass.model";
import axiosInstance from "../../../../interceptor/axiosInstance";
import DeleteAlert from "../../../../shared/components/DeleteAlert";
import PaginationComponent from "../../../../shared/components/PaginationComponent";
import { debounce } from "lodash";
import { PaginationModel } from "../../../../models/PaginationModel/pagination.model";
import { ADMIN_ZOOM_MEETING_PARTICIPANTS } from "../../../../routes/routeConstants/apiRoutes";
interface InstituteLiveClassProps { }

const InstituteLiveClass: FC<InstituteLiveClassProps> = (props: any) => {
  const { user } = props;
  const [showFilters, setFilterVisibility] = useState(false);
  const [showForm, setFormVisibility] = useState(false);
  const [currentLiveClass, setCurrentLiveClass] = useState<LiveClassModel>();
  const [selectedClassID, setSelectedClassID] = useState<number | undefined>(undefined);
  const [selectedClassIDForReport, setSelectedClassIDForReport] = useState<number | undefined>(undefined);
  const [filterValues, setFilterValues] = useState<{
    branchId?: number;
    branchClassRoomId?: number;
    sectionId?: number;
    subjectId?: number;
  }>({});
  const formRef = useRef<any>();
  const [branches, setBranches] = useState<any>();
  const [classRooms, setClassRooms] = useState<any>();
  const [sections, setSections] = useState<any>();
  const [subjects, setSubjects] = useState<any>();
  const params: any = useParams();
  const [deleteVisible, setDeleteVisibility] = useState(false);
  const [search, setSearch] = useState("");
  const [liveClasses, setLiveClasses] = useState<LiveClassModel[]>([]);
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const handleSearch = (value) => {
    setSearch(value);
    fetchInstituteLiveClasses({
      page: pagination.current,
      pageSize: pagination.pageSize,
      search: value,
      ...filterValues,
    });
  };
  const handleFilters = (values: FormikValues) => {
    fetchInstituteLiveClasses({
      page: pagination.current,
      pageSize: pagination.pageSize,
      search,
      ...values,
    });
  };
  const fetchInstituteLiveClasses = (filters: {
    page: number;
    pageSize: number;
    branchId?: number;
    branchClassRoomId?: number;
    sectionId?: number;
    subjectId?: number;
    search?: string;
  }) => {
    setLoading(true)
    LiveClassService.fetchLiveClasses(
      { instituteId: params?.instituteId, ...filters },
      (response, meta) => {
        setLiveClasses(response);
        setPagination({ ...pagination, total: meta?.totalCount, current: params.current_page, pageSize: params.page_size })
        setLoading(false)
      },
      () => { setLoading(false) },
      () => {setLoading(false)  }
    );
  };
  useEffect(() => {
    fetchInstituteLiveClasses({ page: pagination.current, pageSize: pagination.pageSize });
    fetchBranches();
  }, []);


  const debouncedSearchHandler = useMemo(() => debounce(handleSearch, 500), []);

  const fetchBranches = () => {
    BranchService.fetchBranches(
      { institute_id: params?.id },
      (data) => {
        let meta = deserialize(BranchMetaModel, data);
        setBranches(meta);
      },
      () => { },
      () => { }
    );
  };
  const fetchClassRooms = (id: any) => {
    SectionService.fetchBranchClassRooms(
      { branch_id: id },
      (classrooms) => {
        let meta: any = [];
        classrooms?.map((value, index) => {
          meta.push({
            label: value?.classRoom?.name,
            value: value?.id,
            id: value?.classRoom?.classRoomId,
          });
        });

        setClassRooms([...meta]);
      },
      () => { },
      () => { }
    );
  };
  const fetchSections = (id: any) => {
    SectionService.fetchSectionsMeta(
      { branch_class_room_id: id },
      (sections) => {
        setSections(sections);
      },
      () => { },
      () => { }
    );
  };
  const fetchSubjects = (id) => {
    LeaderboardService.fetchSectionSubjects(
      id,
      (subjects) => {
        let meta = deserialize(MetaModel, subjects);
        setSubjects(meta);
      },
      () => { },
      () => { }
    );
  };

  const deleteHandler = () => {
    if (currentLiveClass?.id)
      LiveClassService.deleteLiveClass(
        currentLiveClass?.id,
        () => {
          setDeleteVisibility(false);
          setCurrentLiveClass({});
          fetchInstituteLiveClasses({
            page: pagination.current,
            pageSize: pagination.pageSize,
            ...filterValues,
          });
        },
        () => { },
        () => { }
      );
  };

  const handleTableChange = (pageInfo) => {
    fetchInstituteLiveClasses({ page: pageInfo.current, pageSize: pageInfo.pageSize });
  };

  const joinHandler = (liveClassId: number | undefined) => {
    setSelectedClassID(liveClassId)

    const data = {
      "userType": "admin",
      "userId": user.id,
      "liveClassId": liveClassId,
      'requestFrom':'web'
    }
    LiveClassService.joinLiveClass_Zoom(
      data,
      (joinLink) => {
        window.open(joinLink, "_blank")
      },
      () => { },
      () => { setSelectedClassID(undefined); }
    )
  };

  const generateReportHandler = (liveClassId: number | undefined) => {
    setSelectedClassIDForReport(liveClassId)
   
    const data = {
      "liveClassId": liveClassId,
    }
    LiveClassService.meeting_participants_report(
      data,
      () => { setSelectedClassIDForReport(undefined); }
    )
  };

  return (
    <div className="institute-live-class">
      <DeleteAlert
        title={currentLiveClass?.title}
        detail={""}
        visible={deleteVisible}
        setVisible={setDeleteVisibility}
        deleteText="live class"
        deleteWarning="This live class will be deleted permanently"
        handleDelete={deleteHandler}
      />
      <Formik
        initialValues={filterValues}
        onSubmit={(values) =>
          fetchInstituteLiveClasses({ page: pagination.current, pageSize: pagination.pageSize, ...values })
        }
        enableReinitialize
        innerRef={formRef}
      >
        {({ values, setFieldValue, resetForm }) => (
          <Filters
            expand={showFilters}
            handleApply={() => {
              handleFilters(values);
              setFilterValues(values);
              setFilterVisibility(false);
            }}
            handleReset={() => {
              resetForm({ values: {} });
              setFilterValues({});
              setFilterVisibility(false);
            }}
            closeHandler={() => setFilterVisibility(false)}
          >
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="filter-form__input">
                <div className="filter-form__label">Branch</div>
                <DropdownField
                  name="branchId"
                  placeholder="Select branch"
                  options={branches}
                  value={values?.branchId}
                  onChange={(value) => {
                    setFieldValue("branchId", value);
                    fetchClassRooms(value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
              <div className="filter-form__input">
                <div className="filter-form__label">Class</div>
                <DropdownField
                  name="branchClassRoomId"
                  placeholder="Select class"
                  options={classRooms}
                  value={values?.branchClassRoomId}
                  onChange={(value) => {
                    setFieldValue("branchClassRoomId", value);
                    fetchSections(value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
              <div className="filter-form__input">
                <div className="filter-form__label">Section</div>
                <DropdownField
                  name="sectionId"
                  placeholder="Select section"
                  options={sections}
                  value={values?.sectionId}
                  onChange={(value) => {
                    setFieldValue("sectionId", value);
                    fetchSubjects(value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
              <div className="filter-form__input">
                <div className="filter-form__label">Subject</div>
                <DropdownField
                  name="subjectId"
                  placeholder="Select subject"
                  options={subjects}
                  value={values?.subjectId}
                  onChange={(value) => {
                    setFieldValue("subjectId", value);
                    fetchSubjects(value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
            </Form>
          </Filters>
        )}
      </Formik>
      <InstituteLiveClassForm
        data={currentLiveClass}
        closeHandler={() => setFormVisibility(false)}
        visible={showForm}
        refreshList={() =>
          fetchInstituteLiveClasses({ page: pagination.current, pageSize: pagination.pageSize})
        }
      />
      <div className="header__wrapper">
        <div className="header__left">
          <SearchInput
            placeholder={"Search live class"}
            onChange={debouncedSearchHandler}
          />
          <Button onClick={() => setFilterVisibility(true)}>
            <span>
              <FilterOutlined />
            </span>
            Apply Filter
            {Object.keys(filterValues)?.length !== 0 && (
              <Badge count={Object.keys(filterValues)?.length} />
            )}
          </Button>
        </div>
        {user?.roleName === 'admin' && <div className="header__right">
          <ButtonComponent
            className="header-add-btn"
            buttonContent={"New Live Class"}
            type="primary"
            onClick={() => setFormVisibility(true)}
          />
        </div>}
      </div>
      <Table
        columns={[
          {
            dataIndex: "branch",
            title: "Branch",
            width: 200,
            render: (branch) => <div>{branch?.name}</div>,
            sorter: (a: any, b: any) => {
              return a.branch?.name?.localeCompare(b.branch?.name);
            },
            sortDirections: ["descend", "ascend"],
          },
          {
            dataIndex: "date",
            title: "Date",
            render: (text, record) => (
              <div>{moment(record?.date).format("DD MMM [@]")} {moment(record?.startTime).format("hh:mm A [-]")} {moment(record?.endTime).format("hh:mm A")}</div>
            ),
            width: 250,
            sorter: (a: any, b: any) => {
              if (moment(a.date).isAfter(b.date)) {
                return 1;
              } else {
                return -1;
              }
            },
            sortDirections: ["descend", "ascend"],
          },
          {
            dataIndex: "title",
            title: "Live Class",
            width: 300,
            ellipsis: true,
            sorter: (a: any, b: any) => {
              return a.title?.localeCompare(b.title);
            },
            sortDirections: ["descend", "ascend"],
          },
          {
            dataIndex: "tutors",
            title: "Tutor",
            width: 300,
            render: (text, record) => {
              return (
                <div>
                  {text?.map((value, index) => {
                    return `${value?.fullName}${record?.tutors && record?.tutors?.length - 1 !== index
                        ? ", "
                        : ""
                      }`;
                  })}
                </div>
              );
            },
          },
          {
            dataIndex: "subject",
            title: "Subject",
            sorter: (a: any, b: any) => {
              return a?.subject?.name?.localeCompare(b?.subject?.name);
            },
            sortDirections: ["descend", "ascend"],
            width: 150,
            render: (text) => <div>{text?.name}</div>,
          },
          {
            dataIndex: "classRoom",
            title: "Class",
            sorter: (a: any, b: any) => {
              return a?.classRoom?.name?.localeCompare(b?.classRoom?.name);
            },
            sortDirections: ["descend", "ascend"],
            width: 150,
            render: (text) => <div>{text?.name}</div>,
          },
          {
            dataIndex: "sections",
            title: "Section",
            width: 200,
            render: (text, record) => {
              return (
                <div>
                  {text?.map((value, index) => {
                    return `${value?.name}${record?.sections && record?.sections?.length - 1 !== index
                        ? ", "
                        : ""
                      }`;
                  })}
                </div>
              );
            },
          },
          {
            dataIndex: "isLiveNow",
            title: "Join",
            width: 150,
            render: (isLive, record) => {
              return (
                <ButtonComponent
                  type="primary"
                  buttonContent={"Join Class"}
                  onClick={() => joinHandler(record.id)}
                  loading={selectedClassID === record.id}
                  disabled={!isLive}
                />
              );
            },
          },
          {
            dataIndex: "isLiveNow",
            title: "Participants",
            sortDirections: ["descend", "ascend"],
            width: 150,
            render: (isLive, record) => <div>
              <ButtonComponent
                type="primary"
                buttonContent={"Export"}
                onClick={() => generateReportHandler(record.id)}
                loading={selectedClassIDForReport === record.id}
                disabled={isLive}
              />
            </div>,
          },
          user?.roleName === 'admin' ?
            {
              key: "action",
              fixed: "right",
              width: 50,
              render: (_, record) => (
                <div className="institute-live-class-table__menu">
                  <CardMenu
                    menuText="Live Class"
                    handleDelete={() => {
                      setCurrentLiveClass(record);
                      setDeleteVisibility(true);
                    }}
                    handleEdit={() => {
                      setCurrentLiveClass(record);
                      setFormVisibility(true);
                    }}
                  />
                </div>
              ),
            } : {},
        ]}
        scroll={{ x: 1300 }}
        dataSource={liveClasses}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}
      />
    </div>
  );
};

export default InstituteLiveClass;
